import Rete from "rete";
import {
  StockDataSocket,
  StockDataListControl
} from "../../rete-controls/StockDataListControl.js";
import InMemoryStockData from "../../../Utils/InMemoryStockData.js";
import { ArraySocket } from "../../../Utils/CommonSockets.js";
import Stock from "../../../Utils/Stock.js";

export default class StockBreakOutComponent extends Rete.Component {
  constructor() {
    super("Stock Data Expander"); // name
    //this.stockData = InMemoryStockData.getStockData();
    this._categories = ["Stock Nodes", "tryMe"];
  }

  builder(node) {
    let in1 = new Rete.Input("in1", "StockData", StockDataSocket);
    let out1 = new Rete.Output("out1", "date", ArraySocket);
    let out2 = new Rete.Output("out2", "high", ArraySocket);
    let out3 = new Rete.Output("out3", "low", ArraySocket);
    let out4 = new Rete.Output("out4", "open", ArraySocket);
    let out5 = new Rete.Output("out5", "close", ArraySocket);
    let out6 = new Rete.Output("out6", "vol", ArraySocket);
    return node
      .addInput(in1)
      .addOutput(out1)
      .addOutput(out2)
      .addOutput(out3)
      .addOutput(out4)
      .addOutput(out5)
      .addOutput(out6);
  }

  worker(node, inputs, outputs) {
    let stockData = inputs["in1"][0];
    let data;
    if (stockData === undefined || stockData === []) {
      return;
    }

    data = stockData.getData();
    outputs["out1"] = data.map(x => x.date);
    outputs["out2"] = data.map(x => x.high);
    outputs["out3"] = data.map(x => x.low);
    outputs["out4"] = data.map(x => x.open);
    outputs["out5"] = data.map(x => x.close);
    outputs["out6"] = data.map(x => x.vol);

   // console.log(this.name + " node.data= " + JSON.stringify(node.data));
  //  console.log(this.name + " outputs= " + JSON.stringify(outputs));
  }
}

//ReteComponentStore.add(new OperationsComponent())
